import { Assessment } from "./../models/AssessmentRelated/Assessment";
import { PatientVM } from "./../models/PatientVM";
import { atom } from "recoil";
import {
  AssessmentControl,
  DEFAULT_ASSESSMENT_CONTROL,
} from "../utils/assessment-control";
import { newUser, User } from "../models/User";
import { Lookups, TestType } from "../models/Enums";
import { Option } from "../models/Option";
import { PatientFormDropdowns } from "../models/PatientFormDropdowns";
import { Reports, GaitScore } from "../models/reports";
import { RecommendedExercisesVM } from "../models/RecommendedExercisesVM";
import { LookupDetails } from "../models/LookupDetails";

export const dummyPatient = {
  isNew: true,
  id: -1,
  firstName: "",
  lastName: "",
  nickName: "",
  dob: new Date(),
  email: "",
  zip: "",
  isTestPatient: false,
  patientSetting: 6,
  referralId: -1,
  physicianId: -1,
  departmentId: -1,
  followUpTypeId: -1,
  tagIds: [],
  diagnosisIds: [],
  dobFormatted: "",
  medicationIds: [],
  settingFormField: "",
  isPatientRTMEnabled: false,
  isEverEducated: false,
  isRtmEverEnabled: false,
  externalPatientId: 0,
  isSFTPEhrImportEnabled: false,
  patientLocationId: 0,
} as PatientVM;

export const userDummy = {
  serverId: 12345,
  firstName: "",
  lastName: "",
  location: "",
  username: "",
  password: "",
  email: "",
  country: "",
  state: "",
  gender: "",
  mobilePhone: "",
  officePhone: "",
  address: "",
  zip: "",
  clinicianRoleId: "",
  clinicianRoleName: "",
  isPasswordUpdated: false,
  encryptedServerId: "",
  businessName: "",
  businessId: 0,
  workstationName: "",
  workstationId: 0,
  workstationCode: "",
  businessCode: "",
} as User;

export const newUserDummy = {
  id: 1,
  userName: null,
  password: null,
  canLogin: false,
  markAsDeleted: null,
  tokenExpirationTime: null,
  systemGeneratedPassword: null,
  isRecoveryEmailSent: false,
  tempPasswordCreationTime: null,
  passwordLastUpdatedOn: null,
  lastModifiedUtcTime: null,
  serverId: 49077,
  firstName: "martin1",
  isActiveUser: false,
  middleName: null,
  lastName: "nttini21",
  nickName: null,
  isTestPatient: false,
  mobilePhone: null,
  email: "marnittini21@yopmai.com",
  sex: 0,
  dob: "0001-01-01T00:00:00",
  address: null,
  address2: null,
  city: null,
  state: null,
  zip: "1azxswsad",
  clinicianRoleId: 10,
  clinicianRoleName: "Dr.khan1",
  businessType: 1,
  loggedInUserID: null,
  primaryID: null,
  secondaryID: null,
  workstationId: 3941,
  businessId: 40,
  locationId: 1445,
  applicationLookup: null,
  localDateTime: null,
  utcDateTime: null,
};

export const resetDropDowns: PatientFormDropdowns = {
  settingOpt: [] as Option[],
  setting: new Option(),

  referralOpt: [] as Option[],
  referral: new Option(),

  physicianOpt: [] as Option[],
  physician: new Option(),

  tagsOpt: [] as Option[],
  tags: [] as Option[],

  diagnosisOpt: [] as Option[],
  diagnosis: [] as Option[],

  departmentOpt: [] as Option[],
  department: new Option(),

  roleOpt: [] as Option[],
  role: new Option(),

  medicationsOpt: [] as Option[],
  medications: [] as Option[],

  followUpTypesOpt: [] as Option[],
  followUpType: new Option(),
};

export const newUserState = atom({
  key: "newUserState",
  default: new newUser(),
});
export const createPatientStep2State = atom({
  key: "createPatientStep2State",
  default: false,
});
export const usernameInitialsState = atom({
  key: "usernameInitialsState",
  default: {
    userName: "",
    initials: "",
  },
});

export const dummyDropDowns: PatientFormDropdowns = {
  settingOpt: [] as Option[],
  setting: new Option(),

  referralOpt: [] as Option[],
  referral: new Option(),

  physicianOpt: [] as Option[],
  physician: new Option(),

  tagsOpt: [] as Option[],
  tags: [] as Option[],

  diagnosisOpt: [] as Option[],
  diagnosis: [] as Option[],

  departmentOpt: [] as Option[],
  department: new Option(),

  roleOpt: [] as Option[],
  role: new Option(),

  medicationsOpt: [] as Option[],
  medications: [] as Option[],

  followUpTypesOpt: [] as Option[],
  followUpType: new Option(),
};

export const newAllDropDownState = atom<PatientFormDropdowns>({
  key: "newAllDropDownState",
  default: dummyDropDowns,
});
export const dropDownStateToSave = atom<PatientFormDropdowns>({
  key: "dropDownStateToSave",
  default: dummyDropDowns,
});

export const loggedInUserState = atom({
  key: "loggedInUserState",
  default: userDummy,
});
export const PatientState = atom({
  key: "PatientState",
  default: dummyPatient,
});

export const IseditingDobState = atom({
  key: "IseditingDobState",
  default: {
    IseditingDob: false,
  },
});

export const isShowToast = atom({
  key: "isShowToast",
  default: {
    show: false,
    string: "",
  },
});

export const IseditingLookupsState = atom({
  key: "IseditingLookupsState",
  default: {
    IseditingLookups: false,
    Id: 0,
    Label: "",
    LookUp: 0,
  },
});
export const listOfAssessments = {
  assessments: [] as Assessment[],
};
export const listOfAssessmentsState = atom({
  key: "listOfAssessmentsState",
  default: listOfAssessments,
});
export const listOfExercises = {
  exercises: [] as RecommendedExercisesVM[],
  exercisesRecommendationHistory: [] as any,
  recommendedExercisesBasedOnAssessment: [] as any,
  sidesLookup: [] as any,
  patientDetails: {} as any,
  previouslySelectedExercises: [] as any,
};

export const fixedListOfExercises = {
  exercises: [] as RecommendedExercisesVM[],
  exercisesRecommendationHistory: [] as any,
  recommendedExercisesBasedOnAssessment: [] as any,
  sidesLookup: [] as any,
  patientDetails: {} as any,
  previouslySelectedExercises: [] as any,
};
export const allExercisesState = atom({
  key: "listOfExercises",
  default: listOfExercises,
});

export const fixedAllExercisesState = atom({
  key: "fixedListOfExercises",
  default: fixedListOfExercises,
});

export const defaultAssessment = {
  patientId: 0,
  masterTestId: 0,
  masterVisitId: 0,
  assessmentType: TestType.none, //testlookupid
  testId: 0,
  workstationId: 0,
  locationId: 0,
  visitId: 0,
  phaseId: 0,
  testJson: "",
  testDateTime: new Date(),
  isViewFullSummary: false,
} as Assessment;

export const currentAssessmentState = atom({
  key: "currentAssessmentState",
  default: defaultAssessment,
});

export const selectedAssessmentState = atom({
  key: "selectedAssessmentState",
  default: {
    id: 0,
    name: "",
    isDefault: false,
    isSelected: false,
  },
});
export const networkConnectionStatus = atom({
  key: "networkConnectionStatus",
  default: {
    isShown: false,
  },
});

export const audioInstructionsEnabledState = atom<boolean | null>({
  key: "audioInstructionsEnabledState",
  default: null,
});

// Remote or hand gestures (see utils/assessment-control); saved when leaving for Angle Calibration
export const assessmentControlState = atom<AssessmentControl>({
  key: "assessmentControlState",
  default: DEFAULT_ASSESSMENT_CONTROL,
});

export const defaultJSON = {
  id: -1,
  fallRisk: 0,
  gaitSpeed: 0,
  distance: 0,
  ambulationTime: 0,
  velocity: 0,
  meanNormalizedVelocity: 0,
  numberOfSteps: 0,
  cadence: 0,
  left: {
    stepLength: 0,
  },
  right: {
    stepLength: 0,
  },
} as GaitScore;
export const defaultDetailAssessment = {
  id: 0,
  testType: "",
  note: "",
  date: new Date(),
  visitType: 1,
  therapistFirstname: "",
  therapistLastName: "",
  testName: "",
  time: "",
  score: defaultJSON,
  usedAssistiveDevice: 0,
  startTime: new Date(),
  endTime: new Date(),
} as Reports;

export const duplicateExercise = {
  exercises: [] as RecommendedExercisesVM[],
};

export const duplicateExercisePlanState = atom({
  key: "duplicateExercises",
  default: duplicateExercise,
});

export const newDuplicateExercise = {
  exercises: [] as RecommendedExercisesVM[],
};

export const newDuplicateExercisePlanState = atom({
  key: "newduplicateExercises",
  default: newDuplicateExercise,
});

export const isDuplicateCalledState = atom({
  key: "duplicateCalled",
  default: false, // Initial default value
});

// export const lookupDetails = {
//   lookups: LookupDetails,
// };

export const lookupDetailsState = atom({
  key: "lookupDetailsState",
  default: new LookupDetails(),
});

export const tempListOfExercises = {
  exercises: [] as RecommendedExercisesVM[],
};

export const tempAllExercisesState = atom({
  key: "tempListOfExercises",
  default: tempListOfExercises,
});

// export const reviewPageListOfExercises = {
//   exercises: [] as RecommendedExercisesVM[],
// };

// export const reviewPageListOfExercisesState = atom({
//   key: "reviewPageListOfExercises",
//   default: reviewPageListOfExercises,
// });
